import React from "react";
import { styled } from "styled-components";
import { useTranslation } from "react-i18next";

const MentionsLegales = () => {
  const { t } = useTranslation();

  return (
    <MainContainer>
      <PageTitle>{t("footer.legal")}</PageTitle>

      <SectionContain>
        <Block>
          <p>{t("footer.legal_page.first")}</p>
        </Block>

        <Block>
          <SectionTitle>{t("footer.legal_page.title_two")}</SectionTitle>
          <p>{t("footer.legal_page.two")}</p>
        </Block>

        <Block>
          <SectionTitle>{t("footer.legal_page.title_three")}</SectionTitle>
          <p>{t("footer.legal_page.three")}</p>
        </Block>

        <Block>
          <SectionTitle>{t("footer.legal_page.title_four")}</SectionTitle>
          <p>{t("footer.legal_page.four")}</p>
        </Block>

        <Block>
          <SectionTitle>{t("footer.legal_page.title_five")}</SectionTitle>
          <ContactList>
            <li>{t("footer.legal_page.by_phone")} : 07.45.08.29.97</li>
            <li>
              {t("footer.legal_page.by_email")} : johane.omiscar@gmail.com
            </li>
            <li>
              {t("footer.legal_page.by_mail")} : 9 rue des Colonnes, 75002 PARIS
            </li>
          </ContactList>
        </Block>

        <Block>
          <SectionTitle>{t("footer.legal_page.title_six")}</SectionTitle>
          <p>{t("footer.legal_page.six")}</p>
        </Block>
      </SectionContain>
    </MainContainer>
  );
};

export default MentionsLegales;

/* ─── Styles ──────────────────────────────────────────────────────────────── */

const MainContainer = styled.main`
  max-width: 860px;
  margin: 0 auto;
  padding: 8rem 2rem 5rem 2rem;

  @media (max-width: 768px) {
    padding: 7rem 1.5rem 4rem 1.5rem;
  }

  @media (max-width: 480px) {
    padding: 6rem 1.25rem 3rem 1.25rem;
  }
`;

const PageTitle = styled.h1`
  font-size: 3rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 3rem;

  /* Dégradé blanc → rouge cohérent avec le reste du site */
  //   background: linear-gradient(to right, #ffffff, rgba(180, 1, 18, 0.9));
  //   -webkit-background-clip: text;
  //   -webkit-text-fill-color: transparent;
  //   background-clip: text;

  /* Ligne décorative sous le titre */
  position: relative;
  display: inline-block;
  padding-bottom: 0.5rem;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 50%;
    height: 2px;
    background: linear-gradient(90deg, rgba(180, 1, 18, 0.7), transparent);
    border-radius: 2px;
  }

  @media (max-width: 768px) {
    font-size: 2.2rem;
    margin-bottom: 2rem;
  }

  @media (max-width: 480px) {
    font-size: 1.8rem;
  }
`;

const SectionContain = styled.section`
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  @media (max-width: 768px) {
    gap: 2rem;
  }
`;

const Block = styled.article`
  padding: 1.5rem 1.75rem;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(6px);

  p {
    color: #a8a29e;
    font-size: 1rem;
    line-height: 1.75;
    font-family: "Gowun Batang", serif;
    margin: 0;

    @media (max-width: 480px) {
      font-size: 0.92rem;
    }
  }

  @media (max-width: 480px) {
    padding: 1.25rem 1.25rem;
  }
`;

const SectionTitle = styled.h2`
  font-size: 1.3rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 0.75rem;
  color: #fafafa;

  /* Fine bordure gauche rouge */
  padding-left: 0.75rem;
  border-left: 2px solid rgba(180, 1, 18, 0.7);

  @media (max-width: 768px) {
    font-size: 1.1rem;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const ContactList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-left: 1rem;

  li {
    color: #a8a29e;
    list-style-type: disc;
    font-size: 1rem;
    font-family: "Gowun Batang", serif;
    line-height: 1.6;

    @media (max-width: 480px) {
      font-size: 0.92rem;
    }
  }
`;
